import { render } from "./Formular.vue?vue&type=template&id=6c674dde"
import script from "./Formular.vue?vue&type=script&lang=js"
export * from "./Formular.vue?vue&type=script&lang=js"

import "./Formular.vue?vue&type=style&index=0&id=6c674dde&lang=sass"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QLayout from 'quasar/src/components/layout/QLayout.js';
import QHeader from 'quasar/src/components/header/QHeader.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QBtnGroup from 'quasar/src/components/btn-group/QBtnGroup.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QFooter from 'quasar/src/components/footer/QFooter.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QSplitter from 'quasar/src/components/splitter/QSplitter.js';
import QField from 'quasar/src/components/field/QField.js';import Scroll from 'quasar/src/directives/scroll/Scroll.js';
import Ripple from 'quasar/src/directives/ripple/Ripple.js';
import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QLayout,QHeader,QTabs,QTab,QPageContainer,QBtn,QBtnGroup,QIcon,QTooltip,QBtnDropdown,QList,QItem,QItemSection,QCard,QCardSection,QFooter,QDialog,QLinearProgress,QBadge,QSplitter,QField});qInstall(script, 'directives', {Scroll,Ripple,ClosePopup});
